import { Flex } from 'modules/ui';
import { mediaQuery } from 'modules/utils';
import styled from 'styled-components';

export const DescriptionWrapper = styled.div`
  margin-top: 4.5rem;

  ${mediaQuery('md')} {
    margin-top: 5.125rem;
  }
`;

export const FooterButtonsWrapper = styled(Flex)`
  gap: 1.25rem;
  margin-top: 1rem;

  ${mediaQuery('md')} {
    margin-top: 5.125rem;
  }
`;

export const StyledList = styled.ul`
  margin-bottom: 1.5rem;

  li {
    margin-left: -1rem;

    p {
      margin-bottom: 0.2rem;
    }
  }
`;
